import { type Options, documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, type Block, type Document, type Inline } from "@contentful/rich-text-types";
import Image from "next/image";

const nextImageRenderer = {
    renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node: Block | Inline) => {
            if (node.nodeType !== BLOCKS.EMBEDDED_ASSET) {
                return;
            }

            const file = node.data.target.fields.file;

            if (file.contentType.includes("image")) {
                return (
                    <Image alt="" height={file.details.image.height} src={file.url} width={file.details.image.width} />
                );
            }
        },
    },
};

export function documentToReactComponentsCustom(richTextDocument: Document, options?: Options) {
    const extendedOptions = { ...nextImageRenderer, ...options };

    return documentToReactComponents(richTextDocument, extendedOptions);
}
